/* istanbul ignore file */
import CONFIG from './config';

const { host, apiInterface, withId, withData } = CONFIG;

const PREFIX_URL = `${host}_exclusive/mutual-fund/clients/goals`;
const endpoints = {
  goals: PREFIX_URL,
  configs: `${PREFIX_URL}/configs`,
  packages: `${PREFIX_URL}/packages`,
  calculations: `${PREFIX_URL}/calculations`,
};

const generateInterface = apiInterface.createGenerator('bukareksa', endpoints);

const interfaces = {
  getConfigs: generateInterface('get', 'configs'),
  getPackages: generateInterface('get', 'packages', { withData }),
  getCalculations: generateInterface('get', 'calculations', { withData }),
  postGoals: generateInterface('post', 'goals', { withData }),
  getGoals: generateInterface('get', 'goals', { withData }),
  getGoal: generateInterface('get', 'goals', { withId }),
  getGoalTnc: generateInterface('get', 'goals', { withId, withData, appendUrl: 'term-conditions' }),
  putGoals: generateInterface('put', 'goals', { withId, withData }),
  patchGoal: generateInterface('patch', 'goals', { withId, withData, appendUrl: 'status' }),
  getGoalPortfolios: generateInterface('get', 'goals', { withId, appendUrl: 'portfolios' }),
  getGoalDetailChart: generateInterface('get', 'goals', { withId, appendUrl: 'charts' }),
  getTransactions: generateInterface('get', 'goals', { withId, withData, appendUrl: 'transactions' }),
};

export default interfaces;
